import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}demo-requests/`;

export default {
  fetch(params = {}) {
    return axios.get(API_URL, {
      params,
      headers: buildHeaders(),
    });
  },

  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, {
      headers: buildHeaders(),
    });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  },
};
